import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import apontamentoPontosAmostradosReport from "entity/Indicador/reports/ApontamentoPontosAmostradosReport";
import TableReportHelper from "report/helper";

export default async function perfReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const paramItems = visita.cliente.getParamItems(IndicadorClass, apontamento.tipo);
        const configIndicador = { showTrator: false, showImplemento: false, showFrente: false, showMeta: false, }
        // console.log('paramItems', paramItems)

        content.push([
            await apontamentoHeaderLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                params,
                "un.",
                configIndicador,
                {
                    label: "Operador",
                    field: "operador.operador",
                    width: "*"
                }
            ),
            h.panel(
                [
                    h.row(
                        h.title("Variedade"),
                        h.text(apontamento.insumo),
                    ),
                ],
                { widths: [60, "*",] }
            ),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                [
                    "Perfilhos",
                ],
                // prettier-ignore
                (h) => [
                    h.numberField("perfilhos"),
                ],
                ["*"],
                false // showLocalizacao
            ),

            apontamentoPontosAmostradosReport(visita, indicador, apontamento, paramItems, "QT"),
            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
